const MonthlyAnnualSelector = (props) => {
    return <div className="flex justify-center max-w-[14rem] m-auto mb-8">
        <div className="relative flex w-full p-1 bg-gray-100 border dark:bg-slate-900 rounded-full">
            <span className="absolute inset-0 m-1 pointer-events-none" aria-hidden="true">
                <span className={`absolute inset-0 w-1/2 bg-blue-500 rounded-full shadow-sm shadow-blue-950/10 transform transition-transform duration-150 ease-in-out ${props.monthly ? 'translate-x-0' : 'translate-x-full'}`}></span>
            </span>
            <button className={`relative flex-1 text-sm font-medium h-8 rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-blue-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 ease-in-out ${props.monthly ? 'text-white' : 'text-slate-500 dark:text-slate-400'}`}
                onClick={() => props.setMonthly(true)}
                aria-pressed={props.monthly}>
                Monthly
            </button>
            <button className={`relative flex-1 text-sm font-medium h-8 rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-blue-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 ease-in-out ${props.monthly ? 'text-slate-500 dark:text-slate-400' : 'text-white'}`}
                onClick={() => props.setMonthly(false)}
                aria-pressed={!props.monthly}>
                Annual
            </button>
        </div>
    </div>
}

export default MonthlyAnnualSelector;